export const pushNotificationsRegistration = (
  pushUserId: string,
  pushToken: string
) => ({
  type: 'PUSH_NOTIFICATIONS_REGISTRATION',
  pushUserId,
  pushToken,
});
